export default "__VITE_ASSET__DWm5lnPn__"